import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import GoodReceivedNoteDetail from './GoodReceivedNoteDetail';
import './GoodReceivedNoteDetail.less';

export const prefix = 'bm-p-good-received-note-detail';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: GoodReceivedNoteDetail,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
